import { render, staticRenderFns } from "./KaitouToolbarHorizon.vue?vue&type=template&id=b8802d04&scoped=true&"
import script from "./KaitouToolbarHorizon.vue?vue&type=script&lang=ts&"
export * from "./KaitouToolbarHorizon.vue?vue&type=script&lang=ts&"
import style0 from "./KaitouToolbarHorizon.vue?vue&type=style&index=0&id=b8802d04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8802d04",
  null
  
)

export default component.exports